// ── 홍보물 주문 행 상태 (배경색·필터의 단일 진실) ─────────────────────────────
//   PromotionalTable(색)·OrderCard(색)·색상 필터가 같은 함수를 써 어긋나지 않게 한다.

// 아이템 완료 여부:
//   - 일반 아이템: 택배사+송장번호 모두 입력
//   - 배송불필요+custom_steps: 마지막 custom step 완료
//   - 배송불필요, custom_steps 없음: 완료 체크박스(is_ordered) 기반
export function isItemDone(i) {
  return i.no_shipping
    ? (Array.isArray(i.custom_steps) && i.custom_steps.length > 0
        ? i.workflow_step_id === i.custom_steps.length
        : Boolean(i.is_ordered))
    : Boolean(i.courier?.trim() && i.tracking_number?.trim());
}

/**
 * 주문 행 상태 — styles.js `resolvePromoRowColors` 와 우선순위 동일해야 한다.
 * 우선순위: 배송완료 > 진행중 > 미시작. (취소 아이템은 판정에서 제외.)
 * @returns {'shipped'|'in_progress'|'not_started'}
 */
export function resolvePromoRowState(order) {
  const activeItems = (order.items || []).filter((i) => !i.is_cancelled);
  const allShipped = activeItems.length > 0 && activeItems.every(isItemDone);
  if (allShipped) return 'shipped';
  // 진행중: 일반 아이템 발주 체크됨 또는 배송불필요 단계 진행중
  //   (배송불필요의 is_ordered 는 "완료"이므로 진행중 계산에서 제외)
  const anyInProgress = activeItems.some((i) => (!i.no_shipping && i.is_ordered) || Boolean(i.workflow_step_id));
  if (anyInProgress) return 'in_progress';
  return 'not_started';
}

/**
 * 홍보물 주문 목록 배경색 필터 버튼 정의 (3색 전부 — 사용자 확정).
 * swatch = 행 배경과 같은 색(초록=배송완료, 노랑=진행중, 흰=미시작).
 */
export const PROMO_COLOR_FILTERS = [
  { key: 'shipped',     title: '배송완료', swatch: '#16a34a',        accent: '#16a34a' },
  { key: 'in_progress', title: '진행중',   swatch: '#eab308',        accent: '#d97706' },
  { key: 'not_started', title: '미시작',   swatch: 'var(--bg-card)', accent: '#94a3b8', light: true },
];
